export const getMarkClass = (index: number, fillFrom: number, fillTo: number): string => {
  if (index === fillFrom) {
    return 'bg-[#AEDCFE]'
  } else if (index === fillTo) {
    return 'bg-[#AEDCFE]'
  } else if (index > fillFrom && index < fillTo) {
    return 'bg-[#AEDCFE]'
  }
  return ''
}

export const calculateTooltipPosition = (value: number, cellSize: number): number => {
  const baseOffset = cellSize * (value + 1)
  const centerAdjustment = cellSize / 2

  return baseOffset - centerAdjustment
}
